import React, { useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import {
    FiUser,
    FiLock,
    FiEye,
    FiEyeOff,
    FiShield,
    FiZap,
    FiBarChart2,
} from 'react-icons/fi';
import PublicService from '../../services/public.service';
import './Login.css';


export default function Login() {

    const [username, setUsername] = useState<string>();
    const [password, setPassword] = useState<string>();
    const [captchaToken, setCaptchaToken] = useState<any>();
    const [showPassword, setShowPassword] = useState<boolean>(false);
    const siteKey = process.env.REACT_APP_SITE_KEY || "";
    const [isActive, setIsActive] = useState<boolean>(!siteKey)


    const navigate = useNavigate();

    async function handleCaptchaChange(e: any) {
        setCaptchaToken(e);
        setIsActive(true)
    }


    const handleUserLogin = async () => {
        if (!username || !password) {
            toast.error("All Fields are required")
            return
        }
        await PublicService.userLogin(username, password, captchaToken).then(res => {
            if (res.status === 200) {
                sessionStorage.setItem("bnkauthkey", res.data.token)
                navigate("/dash/dashboard")
            }
        }).catch(e => {
            console.error(e)
            toast.error(e.response.data);
        })
    }

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' && isActive) {
            handleUserLogin();
        }
    };


    return (
        <div className="nx-login">
            {/* Animated background */}
            <div className="nx-login__bg" aria-hidden="true">
                <span className="nx-login__blob nx-login__blob--1" />
                <span className="nx-login__blob nx-login__blob--2" />
                <span className="nx-login__blob nx-login__blob--3" />
                <span className="nx-login__blob nx-login__blob--4" />
            </div>

            <div className="nx-login__shell">

                {/* Brand panel */}
                <div className="nx-login__brand">
                    <div className="nx-login__brand-top">
                        <div className="nx-login__logo">
                            <span className="nx-login__logo-badge">N</span>
                            NIXBNK
                        </div>
                    </div>

                    <div className="nx-login__brand-bottom">
                        <h1 className="nx-login__headline">
                            Welcome back to your control center.
                        </h1>
                        <p className="nx-login__subhead">
                            Manage questions, track growth and stay in command — all from one secure dashboard.
                        </p>

                        <ul className="nx-login__features">
                            <li><FiBarChart2 size={26} /> Real-time analytics &amp; insights</li>
                            <li><FiZap size={26} /> AI-powered question generation</li>
                            <li><FiShield size={26} /> Enterprise-grade security</li>
                        </ul>
                    </div>
                </div>

                {/* Form panel */}
                <div className="nx-login__form-panel">
                    <h2 className="nx-login__welcome">Sign in</h2>
                    <p className="nx-login__welcome-sub">
                        Enter your credentials to access your account
                    </p>

                    <div className="nx-login__field">
                        <label className="nx-login__label" htmlFor="nx-username">User Name</label>
                        <div className="nx-login__input-wrap">
                            <input
                                id="nx-username"
                                className="nx-login__input"
                                type="text"
                                placeholder="Enter your username"
                                autoComplete="username"
                                onChange={(e) => setUsername(e.target.value)}
                                onKeyDown={handleKeyDown}
                            />
                            <span className="nx-login__input-icon"><FiUser /></span>
                        </div>
                    </div>

                    <div className="nx-login__field">
                        <label className="nx-login__label" htmlFor="nx-password">Password</label>
                        <div className="nx-login__input-wrap">
                            <input
                                id="nx-password"
                                className="nx-login__input"
                                type={showPassword ? "text" : "password"}
                                placeholder="Enter your password"
                                autoComplete="current-password"
                                onChange={(e) => setPassword(e.target.value)}
                                onKeyDown={handleKeyDown}
                            />
                            <span className="nx-login__input-icon"><FiLock /></span>
                            <button
                                type="button"
                                className="nx-login__toggle"
                                onClick={() => setShowPassword((v) => !v)}
                                aria-label={showPassword ? "Hide password" : "Show password"}
                            >
                                {showPassword ? <FiEyeOff /> : <FiEye />}
                            </button>
                        </div>
                    </div>

                    {siteKey && (
                        <div className="nx-login__captcha">
                            <ReCAPTCHA
                                sitekey={siteKey}
                                onChange={handleCaptchaChange}
                            />
                        </div>
                    )}

                    <button
                        className="nx-login__submit"
                        onClick={handleUserLogin}
                        disabled={!isActive}
                    >
                        Login
                    </button>

                    <p className="nx-login__footer">
                        © {new Date().getFullYear()} NIXBNK. All rights reserved.
                    </p>
                </div>

            </div>
        </div>
    )
}
